import type { ReactNode } from "react";
import { PlatformDashboardPage } from "./PlatformDashboardPage";

export function KuaishouDashboardPage({ onMenuOpen, platformNav }: { onMenuOpen: () => void; platformNav?: ReactNode }) {
  return <PlatformDashboardPage onMenuOpen={onMenuOpen} platform="kuaishou" platformNav={platformNav} />;
}
